// Age gate (shared by the browser and /api/account/age).
// 13+ to use Animora at all. 13-17 = "teen" band (no gifts / creator subscriptions).
// 18+ = full access. The band is decided ONLY on the server (ageRecords/{uid}); the client can read
// its own record but can never write it (see lib/d1-rules.ts).
export const MIN_AGE = 13
export const ADULT_AGE = 18

export type AgeBand = 'under13' | 'teen' | 'adult'

/** Parses a strict YYYY-MM-DD string. Returns null for anything that is not a real past calendar date. */
export function parseDob(input: unknown): { y: number; m: number; d: number } | null {
  if (typeof input !== 'string' || !/^\d{4}-\d{2}-\d{2}$/.test(input)) return null
  const [y, m, d] = input.split('-').map(Number)
  const dt = new Date(Date.UTC(y, m - 1, d))
  if (dt.getUTCFullYear() !== y || dt.getUTCMonth() !== m - 1 || dt.getUTCDate() !== d) return null
  if (y < 1900 || dt.getTime() > Date.now()) return null
  return { y, m, d }
}

export function ageFromDob(dob: { y: number; m: number; d: number }, now: Date = new Date()): number {
  let age = now.getUTCFullYear() - dob.y
  const before = now.getUTCMonth() + 1 < dob.m || (now.getUTCMonth() + 1 === dob.m && now.getUTCDate() < dob.d)
  if (before) age -= 1
  return age
}

export function bandForAge(age: number): AgeBand {
  return age < MIN_AGE ? 'under13' : age < ADULT_AGE ? 'teen' : 'adult'
}
